import { Button, HTMLChakraProps } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDownIcon, ChevronUpIcon } from 'src/icons'

interface Props {
  expanded: boolean
  onToggle(): void
  itemProps?: HTMLChakraProps<any>
}

// « Voir plus / Voir moins » under a list cut at `max` items (tensions,
// projects, next steps in the sidebar). The caller renders it AFTER the whole
// list, hidden part included: unfolded, the button follows the list down
// instead of staying stuck between the 5th and the 6th item (#122).
export default function SeeMoreButton({
  expanded,
  onToggle,
  itemProps,
}: Props) {
  const { t } = useTranslation()
  return (
    <Button
      variant="link"
      justifyContent="start"
      w="100%"
      p={1}
      {...itemProps}
      pl="28px"
      fontSize="inherit"
      leftIcon={
        expanded ? <ChevronUpIcon size="1em" /> : <ChevronDownIcon size="1em" />
      }
      onClick={onToggle}
    >
      {expanded ? t('common.seeLess') : t('common.seeMore')}
    </Button>
  )
}
